import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { OpeExt } from "src/app/models/OpeExt";
import { OpeExtDtoResponse } from "src/app/models/OpeExtDtoResponse";
import { entite } from "src/app/models/entite";
import { entiteAdd } from "src/app/models/entiteAdd";
import { formejuridique } from "src/app/models/formjuridique";
import { typeSociete } from "src/app/models/typeSociete";
import { environment } from "src/environments/environment";
@Injectable({
  providedIn: 'root'
})
export class EntitebackService {

  PATH_GET_ALL_ENTITIES = "/vendeurs/entite/getAllentites";
  PATH_GET_ENTITY_PERE = "/vendeurs/entite/getEntitesPeres";
  PATH_ADD_ENTITY = "/vendeurs/entite/add/";
  PATH_GET_SOCIETY_TYPE = "/vendeurs/entite/getTypeSociete";
  PATH_GET_FORM_JURIDIQ = "/vendeurs/entite/getFormjuridique";
  PATH_GET_ENTITY_BY_ID = "/vendeurs/entite/getEntitebyid/"
  PATH_GET_SOC_BY_CODE = "/vendeurs/entite/getTypesocietebycode/";
  PATH_GET_FORMJURIDIQ_BY_CODE = "/vendeurs/entite/getFormjuridbycode/";
  PATH_ENTITY_UPDATE = "/vendeurs/entite/update/";
  PATH_ENTITY_DELETE = "/vendeurs/entite/update";
  PATH_ENTITY_GET_OPE = "/vendeurs/entite/getOpe/";
  PATH_ENTITY_GETOPEBYNUM = "/vendeurs/entite/getListOpeBynumEntite/";

  constructor(private http: HttpClient) { }

  getAllEntites = (): Observable<entite[]> => {

    let url = environment.host.domaine + this.PATH_GET_ALL_ENTITIES;
    // let headers = new HttpHeaders({ 'accept': '*/*'});

    return this.http.get<entite[]>(url);

  }

  getEntitesPeres = (): Observable<entite[]> => {

    let url = environment.host.domaine + this.PATH_GET_ENTITY_PERE;
    // let headers = new HttpHeaders({ 'accept': '*/*'});
    return this.http.get<entite[]>(url);

  }
  /** POST: add a new enite to the EIPFIC and EXTRAV */
  addEntite(entiteAdd: entiteAdd): Observable<HttpResponse<any>> {
    //https://cloud-ide-extrav-realestate.staging.echonet/user/e77868/http/8091/entite/add
    let url = environment.host.domaine + this.PATH_ADD_ENTITY + (entiteAdd.num_pere === null || entiteAdd.num_pere === undefined ? 0 : entiteAdd.num_pere);
    let headers = new HttpHeaders({ 'accept': 'application/json' });
    return this.http.post<any>(url, {

      libelle: entiteAdd.libelle,
      adresse1: entiteAdd.adresse1,
      adresse2: entiteAdd.adresse2 === null || entiteAdd.adresse2 === undefined ? '' : entiteAdd.adresse2,
      adresse3: entiteAdd.adresse3 === null || entiteAdd.adresse3 === undefined ? '' : entiteAdd.adresse3,
      codePostal: entiteAdd.code_postal,
      ville: entiteAdd.ville,
      type: entiteAdd.type,
      ext: entiteAdd.ext,
      formeJuridique: entiteAdd.formeJuridique === null || entiteAdd.formeJuridique === undefined ? '' : entiteAdd.formeJuridique,
      tel: entiteAdd.tel === null || entiteAdd.tel === undefined ? '' : entiteAdd.tel,
      web: "0",
      user: "BNE77868",
      axe: "C00",
      statut: entiteAdd.statut

    },
      { headers: headers, observe: 'response' });
  }

  getTypeSociete(): Observable<typeSociete[]> {

    let url = environment.host.domaine + this.PATH_GET_SOCIETY_TYPE
    return this.http.get<typeSociete[]>(url);

  }

  getFormjuridique(): Observable<formejuridique[]> {

    let url = environment.host.domaine + this.PATH_GET_FORM_JURIDIQ;
    return this.http.get<formejuridique[]>(url);

  }

  getEntitebyId(numEntite: number): Observable<entite> {
    let url = environment.host.domaine + this.PATH_GET_ENTITY_BY_ID + numEntite;
    return this.http.get<entite>(url );

  }

  getTypeSocietebyCode(a1code: string): Observable<typeSociete> {

    let url = environment.host.domaine + this.PATH_GET_SOC_BY_CODE + a1code;
    return this.http.get<typeSociete>(url);

  }

  getFormjuridbyCode(a1code: string): Observable<formejuridique> {
    let url = environment.host.domaine + this.PATH_GET_FORMJURIDIQ_BY_CODE + a1code

    return this.http.get<formejuridique>(url);

  }
  /** PUT : UPDAT ENTITE EIPFIC and EXTRAV */
  updateEntite(entiteAdd: entiteAdd): Observable<HttpResponse<any>> {

    let url = environment.host.domaine + this.PATH_ENTITY_UPDATE + (entiteAdd.num_pere === null || entiteAdd.num_pere === undefined ? 0 : entiteAdd.num_pere);
    let headers = new HttpHeaders({ 'accept': 'application/json' });

    return this.http.put<any>(url, {

      numEntite: entiteAdd.numEntite,
      libelle: entiteAdd.libelle,
      adresse1: entiteAdd.adresse1,
      adresse2: entiteAdd.adresse2 === null || entiteAdd.adresse2 === undefined ? '' : entiteAdd.adresse2,
      adresse3: entiteAdd.adresse3 === null || entiteAdd.adresse3 === undefined ? '' : entiteAdd.adresse3,
      codePostal: entiteAdd.code_postal,
      ville: entiteAdd.ville,
      type: entiteAdd.type,
      ext: entiteAdd.ext,
      formeJuridique: entiteAdd.formeJuridique === null || entiteAdd.formeJuridique === undefined ? '' : entiteAdd.formeJuridique,
      tel: entiteAdd.tel === null || entiteAdd.tel === undefined ? '' : entiteAdd.tel,
      web: "0",
      user: "BNE77868",
      axe: "C00",
      statut: entiteAdd.statut === null || entiteAdd.statut === undefined ? '' : entiteAdd.statut,

    },
      { headers: headers, observe: 'response' });

  }

  getOpeExt(): Observable<OpeExt[]> {

    let url = environment.host.domaine + this.PATH_ENTITY_GET_OPE;

    return this.http.get<OpeExt[]>(url);

  }
  getOpeExtAffecteEntite(numEntite: number): Observable<OpeExtDtoResponse[]> {

    const url = environment.host.domaine + this.PATH_ENTITY_GETOPEBYNUM + numEntite;
    return this.http.get<OpeExtDtoResponse[]>(url);

  }

  deleteOpeFromEntite(numEntite: number,numOpe: number): Observable<void> {
    let url = environment.host.domaine + this.PATH_ENTITY_DELETE;
    return this.http.put<void>(url,{numEntite: numEntite,numOpe : numOpe});
  }

}